module.exports = __webpack_public_path__ + "static/media/guigo_partners_black.7d0f9277.svg";